import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal, message } from 'antd';
import { PauseOutlined, CaretRightOutlined } from '@ant-design/icons';
import HTTP from '../../../script/service';
import Util from '../../../script/util';
import './FullGive.scss';

class FullGive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      play: false,
      code: false,
    };
  }
  showModal = (ds) => {
    HTTP._get_sound_report({
      uid: ds.uid,
    }).then((res) => {
      if (res.code == 200) {
        this.setState({
          ds: { ...res.data },
          visible: true,
          code: false,
        });
      } else {
        message.error(res.message);
      }
    });
  };
  hideModal = () => {
    this.audioEnded();
    this.setState({
      visible: false,
    });
  };
  changePlay = () => {
    const { play } = this.state;
    this.setState({
      play: !play,
    });
    if (!play) {
      this.vadioElement && this.vadioElement.play();
    } else {
      this.vadioElement && this.vadioElement.pause();
    }
  };
  showCode = () => {
    this.setState({
      code: true,
    });
  };
  //停止播放
  audioEnded = () => {
    this.setState({
      play: false,
    });
    this.vadioElement && this.vadioElement.pause();
  };
  render() {
    const { visible, ds, play, code } = this.state;
    return (
      <div>
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title="声鉴报告"
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="440px"
          zIndex="1002"
          onCancel={this.hideModal}
        >
          <div className="full-give-plan">
            {code ? (
              <div className="code-bg"></div>
            ) : (
              <div>
                {ds ? (
                  <div className="full-give-content">
                    <audio
                      style={{ display: 'none' }}
                      src={Util.transImgUrl(ds.voiceUrl)}
                      onEnded={this.audioEnded}
                      ref={(el) => (this.vadioElement = el)}
                    />
                    <div className={play ? 'give-top play' : 'give-top'}>
                      <div className="give-center">
                        <span className="g-state" onClick={this.changePlay}>
                          {play ? <PauseOutlined /> : <CaretRightOutlined />}
                        </span>
                        <label>心动值：{ds.love}</label>
                      </div>
                    </div>
                    <div className="evaluate">音色评价：{ds.evaluate}</div>
                    <div className="full-detail">
                      <dl className={ds.sex == 1 ? 'p-wman' : 'p-man'}>
                        <dt>
                          <span>主音色</span>
                        </dt>
                        <dd>
                          {ds.mainTimbreJson.map((item, index) => (
                            <div className="fu-item" key={index}>
                              <label className="name">{item.label}</label>
                              <span className="line">
                                <i style={{ width: item.percent }}></i>
                              </span>
                              <label className="percent">{item.percent}</label>
                            </div>
                          ))}
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          <span>辅音色</span>
                        </dt>
                        <dd>
                          {ds.assistTimbreJson.map((item, index) => (
                            <div className="fu-item" key={index}>
                              <label className="name">{item.label}</label>
                              <span className="line">
                                <i style={{ width: item.percent }}></i>
                              </span>
                              <label className="percent">{item.percent}</label>
                            </div>
                          ))}
                        </dd>
                      </dl>
                      <div className="accs">
                        <button
                          className="daidai-btn-primary"
                          onClick={this.showCode}
                        >
                          我要鉴音
                        </button>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(FullGive, { withRef: true });
